import { BaseService } from '@flint/framework';

export default class AddSubscription extends BaseService {
  constructor() {
    super("ADDING_SUBSCRIPTION_DATA", 'AddSubscriptionStore', true);
  }

  handleEvent(eventName, subscription) {
    return this.getClient('vetService').post('/admin-api/subscriptions/', subscription);
  }
}